import React, { useEffect, useState } from 'react'
import {apiMy, apiExit, apiSubs} from 'api-methods'
import {saveToLocalStorage} from 'helper-func'
import '../css/Header.css'
import {Link, useLocation, useNavigate} from "react-router-dom";
import { handleAuthErrorAndRedirect, isSuccessStatus } from '../utils/authError'

const Header = () => {
    const [logoLoad, setLogoLoad] = useState(false)
    const [logo, setLogo] = useState('')
    const [companyName, setCompanyName] = useState('')
    const [userName, setUserName] = useState('')
    const navigate = useNavigate()
    const routerLocation = useLocation()
    const currentPath = routerLocation.pathname

    function funcLogOut () {apiExit().then(_ => {}).catch(_ => {}).finally(_ => {navigate('/')})}

    useEffect(() => {try {const logoPath = require('../img/logoZ2.png'); setLogo(logoPath); setLogoLoad(true)} catch (_) {}}, [])

    useEffect(() => {
        apiMy()
            .then(data => {
                if (handleAuthErrorAndRedirect({statusCode: data.code, navigate, location: routerLocation})) return
                if (isSuccessStatus(data.code)) {
                    if (typeof data.data === 'string') {data.data = JSON.parse(data.data)}
                    saveToLocalStorage('isLdap', data.data?.isLdap === true)
                    setCompanyName(data.data.customerOptions?.company?.name)
                    setUserName(data.data.login)
                }
            })
            .catch(_ => {})
    }, [])

    function downloadReport() {
        apiSubs({"csv": 1})
            .then(data => {
                if (handleAuthErrorAndRedirect({statusCode: data.code, navigate, location: routerLocation})) return
                if (isSuccessStatus(data.code)) {
                    const BOM = '\uFEFF';
                    const csvContent = BOM + data.data;

                    const blob = new Blob([csvContent], {
                        type: 'text/csv;charset=utf-8;'
                    })
                    const url = URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'subscriptions.csv')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    URL.revokeObjectURL(url)
                }
            })
            .catch(_ => {})
    }

    return (
        <header className="app-header">
            <div className="header_lev1">
                <div className="header-topbar">
                    <div className="header-brand">
                        <Link className="header-logo-link" to="/panel/company/editcompany">
                            <div className="header-logo"></div>
                            <div className="header-brand-copy">
                                <span className="header-company-name">{companyName || 'Компания'}</span>
                            </div>
                        </Link>
                    </div>
                    <div className="header-user-actions">
                        <Link className="header-profile-link" to="/panel/personal" aria-label="Профиль пользователя">
                            <div className="profile-icon"></div>
                        </Link>
                        <div className="header-user-name">{userName || 'Пользователь'}</div>
                        <button type="button" className="header-logout-button" onClick={_ => funcLogOut()} aria-label="Выйти">
                            <div className="iconExit" />
                        </button>
                    </div>
                </div>
            </div>

            <div className="header_lev2">
                <div className="header-nav-shell">
                    <div className="header-nav-content">
                        <div className="header-nav-links">
                            <Link className={(['/backoffice/subscriptions','/']).indexOf(currentPath) > -1 ? 'active' : ''} to="/backoffice/subscriptions"><div>Подписки</div></Link>
                            <Link className={currentPath === '/reports/index' ? 'active' : ''} to="/reports/index"><div>Отчёты</div></Link>
                            {
                                (['/panel/company/editcompany', '/panel/company/usersmanegment', '/panel/adduser']).indexOf(currentPath) > -1
                                && <Link className={currentPath === '/panel/company/editcompany' ? 'active' : ''} to="/panel/company/editcompany"><div>Параметры</div></Link>
                            }
                            {
                                (['/panel/company/editcompany', '/panel/company/usersmanegment', '/panel/adduser']).indexOf(currentPath) > -1
                                && <Link className={currentPath === '/panel/company/usersmanegment' ? 'active' : ''} to="/panel/company/usersmanegment"><div>Пользователи</div></Link>
                            }
                        </div>
                        <div className="header-toolbar-actions">
                            {
                                currentPath === '/backoffice/subscriptions'
                                && <button type="button" className="header-action-button header-action-button--secondary" onClick={_ => downloadReport()}><div>Выгрузить в CSV</div></button>
                            }
                            {
                                (['/backoffice/subscriptions', '/backoffice/editsubscription/returl/backoffice/subscriptions', '/']).indexOf(currentPath) > -1
                                && <Link className={`header-action-button header-action-button--primary ${currentPath === '/backoffice/editsubscription/returl/backoffice/subscriptions' ? 'active' : ''}`} to="/backoffice/editsubscription/returl/backoffice/subscriptions"><div>Подключить подписку</div><div className="plusImage"></div></Link>
                            }


                            {
                                currentPath === '/panel/company/usersmanegment'
                                && <Link className={`header-action-button header-action-button--primary ${currentPath === '/panel/adduser' ? 'active' : ''}`} to="/panel/adduser"><div>Добавить пользователя</div><div className="plusImage"></div></Link>
                            }


                            {
                                (['/panel/personal', '/panel/changepasswordform', '/backoffice/tablesettings']).indexOf(currentPath) > -1
                                && <Link className={`header-action-button header-action-button--tertiary ${currentPath === '/panel/personal' ? 'active' : ''}`} to="/panel/personal"><div>Данные пользователя</div></Link>
                            }
                            {
                                (['/panel/personal', '/panel/changepasswordform', '/backoffice/tablesettings']).indexOf(currentPath) > -1
                                && <Link className={`header-action-button header-action-button--tertiary ${currentPath === '/panel/changepasswordform' ? 'active' : ''}`} to="/panel/changepasswordform"><div>Сменить пароль</div></Link>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header
